/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable space-before-function-paren */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { HttpClient } from '@angular/common/http';
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { API_URLS } from '../../../../../@shelter/utils/API_URLS';
import { OverrideService } from '../../../../../@shelter/utils/override.service';

@Component({
    selector: 'image-picker',
    templateUrl: './image-picker.component.html',
    styleUrls: ['./image-picker.component.scss'],
})
export class ImagePickerComponent implements OnInit {
    @Input() accept: string = 'image/*';
    @Input() class: string = 'flex-auto col-12 ml-2 mr-2 gt-xs:pr-3 mb-1';
    @Input() controlName: string;
    @ViewChild('fileUpload', { static: true, read: TemplateRef })
    fileUpload: TemplateRef<any>;
    fileUploadUrl: string = API_URLS.File.upload;
    @Input() form: FormGroup;
    @Input() isRequired: boolean = false;
    @Input() label: string;
    @Input() type: 'image' | 'video' = 'image';
    @Output() uploaded = new EventEmitter<string>();
    @Input() value: string;
    @Input() width?: number;
    @Input() height?: number;
    constructor(
        public override: OverrideService,
        private http: HttpClient,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit(): void {}

    openUpload(eve) {
        this.fileUpload?.elementRef?.nativeElement?.click();
    }

    uploadImage(event) {
        if (this.form && this.controlName) {
            this.form.get(this.controlName).reset();
        }
        const file = event.target.files[0];
        if (this.width && this.height) {
            const reader = new FileReader();

            //Read the contents of Image File.
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                //Initiate the JavaScript Image object.
                const image = new Image();

                //Set the Base64 string return from FileReader as source.
                image.src = e.target.result as string;
                //console.log('image: ',image);
                
                //Validate the File Height and Width.
                image.onload = () => {
                    console.log('image', image.width, image.height);
                    if (
                        this.width !== image.width ||
                        this.height !== image.height
                    ) {
                        alert(
                            'Height must be ' +
                                this.height +
                                'px and Width must be ' +
                                this.width +
                                'px.'
                        );
                        return false;
                    } else {
                        this.uploadImageToServer(file);
                        return true;
                    }
                };
            };
        } else {
            this.uploadImageToServer(file);
        }
    }

    uploadImageToServer(file) {
        const formData = new FormData();
        formData.append('file', file);

        this.http
            .post(`${this.fileUploadUrl}`, formData)
            .subscribe((res: any) => {
                if(res) {
                    this.uploaded.emit(res.id);
                    if (this.form && this.controlName) {
                    this.form.get(this.controlName).patchValue(res.id);
                    this.changeDetector.detectChanges();
                    }
                }
                 
            },
            (err)=>{
              //  console.log('error', err);
                if(err) {
                alert(
                    `expected size is less than 2MB` 
                );
                return false;
                }

            });
    }
}
